import { ActionMenuOption, AllowedActionMenuElements } from 'ui/actionMenu/types';
import { useTranslation } from 'modules/domains/list';
import { CHANNEL_UNSUBSCRIBE_URL } from '../../../constants';

export const useUnsubscribeUsersFromChannelLink = (): ActionMenuOption => {
  const { t } = useTranslation();
  return {
    as: AllowedActionMenuElements.Link,
    content: t('indexPage.pageActions.unsubscribeUsersFromChannel'),
    href: CHANNEL_UNSUBSCRIBE_URL,
    id: 'channel-unsubscribe-link',
  };
};
